import SiteLayout from "@/components/SiteLayout";
import { CONTACT_CONTENT, SITE } from "@/data/siteContent";
import { usePageMeta } from "@/hooks/usePageMeta";

const ContactPage = ({ language = "fr" }) => {
  const content = CONTACT_CONTENT[language] || CONTACT_CONTENT.fr;
  const metaTitle = content.title || "Contact";
  const metaDescription = content.subtitle || "Contactez-nous";

  usePageMeta(metaTitle, metaDescription);
  const isFr = language === "fr";

  return (
    <SiteLayout language={language}>
      <section className="py-16 md:py-24 bg-gradient-to-br from-slate-50 to-white">
        <div className="max-w-6xl mx-auto px-6 md:px-12 lg:px-24 space-y-10">
          <div className="space-y-4">
            <p className="text-xs uppercase tracking-[0.4em] text-secondary" data-testid="contact-eyebrow">
              {isFr ? "Soumission" : "Estimate"}
            </p>
            <h1 className="text-3xl md:text-5xl font-bold text-primary" data-testid="contact-title">
              {content.title}
            </h1>
            <p className="text-lg text-muted-foreground" data-testid="contact-subtitle">
              {content.subtitle}
            </p>
          </div>

          <div className="grid gap-10 lg:grid-cols-[1.2fr_0.8fr]">
            <div
              className="border border-border bg-white p-8 shadow-sm"
              style={{ marginTop: "30px", marginBottom: "30px" }}
              data-testid="contact-spaceleadx-section"
            >
              <h2 className="text-2xl font-bold text-primary" data-testid="contact-form-title">
                {content.formTitle}
              </h2>
              <div className="mt-6">
                <iframe
                  title="Formulaire de soumission"
                  src="https://spaceleadx.ai/soumission/estimation-pave-uni"
                  width="100%"
                  height="1100"
                  frameBorder="0"
                  style={{
                    border: "none",
                    maxWidth: "600px",
                    margin: "0 auto",
                    display: "block",
                  }}
                  data-testid="contact-spaceleadx-iframe"
                />
              </div>
            </div>

            <div className="space-y-8">
              <div className="border border-border bg-white p-6 shadow-sm" data-testid="contact-info-panel">
                <h2 className="text-xl font-bold text-primary" data-testid="contact-info-title">
                  {content.infoTitle}
                </h2>
                <div className="mt-4 space-y-3 text-sm text-muted-foreground">
                  <a
                    href={`tel:${SITE.phone}`}
                    className="block text-primary font-semibold"
                    data-testid="contact-info-phone"
                  >
                    {SITE.phoneDisplay}
                  </a>
                  <a
                    href={`mailto:${SITE.email}`}
                    className="block"
                    data-testid="contact-info-email"
                  >
                    {SITE.email}
                  </a>
                  <span data-testid="contact-info-address">{SITE.address}</span>
                </div>
              </div>

              <div className="border border-border bg-white p-6 shadow-sm" data-testid="contact-map-panel">
                <h2 className="text-xl font-bold text-primary" data-testid="contact-map-title">
                  {content.mapTitle}
                </h2>
                <div className="mt-4">
                  <iframe
                    title="Service area map"
                    src="https://www.google.com/maps?q=20%20Rue%20Mansart%20Saint-Jean-sur-Richelieu%20QC%20J2W%201W6&output=embed"
                    className="w-full h-64 border-0"
                    loading="lazy"
                    data-testid="contact-map-iframe"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
};

export default ContactPage;